<app-header></app-header>
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-spin-clockwise" [fullScreen] = "true"></ngx-spinner>
<app-booking-header></app-booking-header>


<div class="wrap">
  <main class="main">
    <section class="wgt wgt-checkout" *ngIf="!loading">
      <div class="container multi-step-form">
        <img *ngIf="image != null" [src]="image" alt="Referral Header" class="header-image">

        <div *ngIf="referralComplete">
          <div class="survey-intro" [innerHTML]="referralDetails.completionText"></div>
        </div>

        <ng-container *ngIf="!referralComplete">
        <div class="survey-intro" [innerHTML]="referralDetails.introductionText"></div>

        <form method="post" id="booking_edit-details" novalidate="novalidate" class="form-dashboard form-account" [formGroup]="referralForm" (ngSubmit)="onReferralFormSubmit()">

          <div class="card">
            <div class="row row-border">
              <h3 class="span-heading title-label">
                Your Details
              </h3>

              <div class="span-input span-select  required">
                <select
                  id="title"
                  name="title"
                  type="select"
                  class="input-select"
                  formControlName="titleSelect"
                  appParsleyValidation
                  [submitted]="referralFormSubmitted"
                  [elementName]="'Title'"
                >
                  <option value="" disabled selected hidden>title</option>
                  <option value="Dr.">Dr.</option>
                  <option value="Lady">Lady</option>
                  <option value="Lord">Lord</option>
                  <option value="Master">Master</option>
                  <option value="Miss">Miss</option>
                  <option value="Mr.">Mr.</option>
                  <option value="Mrs.">Mrs.</option>
                  <option value="Ms.">Ms.</option>
                  <option value="Prof.">Prof.</option>
                  <option value="Rev.">Rev.</option>
                  <option value="Sir">Sir</option>
                </select>
                <i class="asterisk">*</i>
                <i class="checkmark"></i>
                <ul class="parsley-errors-list filled"></ul>
              </div><div class="span-input span-text required">
              <input
                type="text"
                id="givenName"
                name="givenName"
                class="input-text"
                formControlName="givenNameInput"
                appParsleyValidation
                [submitted]="referralFormSubmitted"
                [elementName]="'First Name'"
              />
              <label for="givenName" class="floating-label">
                first name
              </label>
              <i class="asterisk">*</i>
              <i class="checkmark"></i>
              <ul class="parsley-errors-list filled"></ul>
            </div>

              <div class="span-input span-text required">
                <input
                  type="text"
                  id="familyName"
                  name="familyName"
                  class="input-text"
                  formControlName="familyNameInput"
                  appParsleyValidation
                  [submitted]="referralFormSubmitted"
                  [elementName]="'Surname'"
                />
                <label for="familyName" class="floating-label">
                  surname
                </label>
                <i class="asterisk">*</i>
                <i class="checkmark"></i>
                <ul class="parsley-errors-list filled"></ul>
              </div><div class="span-input span-text required">
              <input
                type="email"
                id="email"
                name="email"
                class="input-text"
                formControlName="emailInput"
                appParsleyValidation
                [submitted]="referralFormSubmitted"
                [elementName]="'Email'"
                (input)="referralForm.controls.emailInput.setValue(referralForm.controls.emailInput.value.toLowerCase())"
              />
              <label for="email" class="floating-label">
                email
              </label>
              <i class="asterisk">*</i>
              <i class="checkmark"></i>
              <ul class="parsley-errors-list filled"></ul>
            </div><div class="span-input span-text required">
              <input
                type="text"
                id="phoneNumber"
                name="phoneNumber"
                class="input-text"
                formControlName="telephoneHomeInput"
                (focusout)="formatTelephone()"
                appParsleyValidation
                [submitted]="referralFormSubmitted"
                [elementName]="'Telephone'"
              />
              <label
                for="phoneNumber"
                class="floating-label">
                phone
              </label>
              <i class="asterisk">*</i>
              <i class="checkmark"></i>
              <ul class="parsley-errors-list filled"></ul>
            </div><div class="span-input span-select  required">
              <select
                id="venue"
                name="venue"
                class="input-select"
                formControlName="venueSelect"
                appParsleyValidation
                [submitted]="referralFormSubmitted"
                [elementName]="'Venue'"
              >
                <option value="" disabled selected hidden>your nearest venue</option>

                <option *ngFor="let venue of venues" value="{{venue.id}}">{{venue.venueName}} - {{venue.venueLocality}}</option>
              </select>
              <i class="asterisk">*</i>
              <i class="checkmark"></i>
              <ul class="parsley-errors-list filled"></ul>
            </div><div class="span-input span-select  required">
              <select
                id="program"
                name="program"
                class="input-select"
                formControlName="programSelect"
                appParsleyValidation
                [submitted]="referralFormSubmitted"
                [elementName]="'Program'"
              >
                <option value="" disabled selected hidden>which programme are you interested in?</option>

                <option *ngFor="let program of programs" value="{{program.id}}">{{program.programName}}</option>
              </select>
              <i class="asterisk">*</i>
              <i class="checkmark"></i>
              <ul class="parsley-errors-list filled"></ul>
            </div><div class="span-input span-textarea  required">
              <textarea
                id="notes"
                name="notes"
                class="input-text"
                placeholder="notes"
                formControlName="notesTextArea"
                appParsleyValidation
                [submitted]="referralFormSubmitted"
                [elementName]="'Notes'"
              ></textarea>
              <label
                for="notes"
                class="sr-only"
              >
                notes
              </label>

              <i class="asterisk">*</i>
              <i class="checkmark"></i>
              <ul class="parsley-errors-list filled"></ul>
            </div>					</div>

            <button type="submit" class="btn btn-block btn-red" [ngClass]="this.referralForm.invalid || runningUpdate ? 'disabled' : ''">submit</button>				</div>

        </form>
        </ng-container>
      </div>
    </section>
  </main>
</div>
